export enum RoleTypeSM {
    Unknown = 0,
    SuperAdmin = 1,
    SystemAdmin = 2,
    ClientAdmin = 3,
    ClientEmployee = 4,
    CompanyAutomation = 5,
    BlogAdmin = 6
}